export default __webpack_public_path__ + "static/media/inner-banner-2.5ca29492.png";